import React, {Component} from 'react'
import classNames from 'classnames'
import scroll from 'window-scroll'
import Article from '../../components/Article'
import {CONTENT_TYPE_ARTICLE} from '../../constants/articles'
import {throttle} from '../../utils/throttle'
import {hasArticleReadCookie, hasSubscribedCookie, setArticleReadCookie} from '../../utils/cookies'
import ErrorPage from 'pages/ErrorPage'
import {useGatedContent} from 'env'

const HEIGHT_MAGIC_NUMBERS = 66 + 177 // approx the height of the site header and the categories selector

class ArticlePage extends Component {
  constructor (props) {
    super(props)
    this.subscriptionListenersSet = false
    this.state = {
      articleHeightRestriction: 0,
      overlayOpacity: 0
    }
    this.handleScroll = throttle(this.handleScroll.bind(this), 50)
    this.handleResize = this.handleResize.bind(this)
    this.handleArticleRef = this.handleArticleRef.bind(this)
    this.updateArticleHeightRestriction = this.updateArticleHeightRestriction.bind(this)
  }

  componentDidMount () {
    this.checkSubscriptionRequired()
  }

  componentWillUnmount () {
    this.removeSubscriptionListeners()
  }

  componentDidUpdate () {
    if (!this.props.subscriptionRequired && this.subscriptionListenersSet) {
      this.removeSubscriptionListeners()
    }
  }

  addSubscriptionListeners () {
    window.addEventListener('scroll', this.handleScroll, {passive: true})
    window.addEventListener('resize', this.handleResize)
    this.subscriptionListenersSet = true
  }

  removeSubscriptionListeners () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
    this.subscriptionListenersSet = false
  }

  checkSubscriptionRequired () {
    const {setArticleSubscriptionRequired, setNewsletterSubscribed} = this.props
    if (hasSubscribedCookie()) {
      setNewsletterSubscribed()
      return
    }
    if (!hasArticleReadCookie()) {
      setArticleReadCookie()
      return
    }
    setArticleSubscriptionRequired(true)
    this.addSubscriptionListeners()
    this.calculateArticleHeightRestriction()
  }

  calculateArticleHeightRestriction () {
    if (!this.articleRef) return
    this.setState({
      articleHeightRestriction: (this.articleRef.scrollHeight / 2)
    })
  }

  handleScroll () {
    const {articleHeightRestriction} = this.state
    const minimum = articleHeightRestriction - ((window.innerHeight - HEIGHT_MAGIC_NUMBERS))
    const maximum = articleHeightRestriction
    const scrollY = scroll.getScrollY()
    if (scrollY < minimum) {
      this.setState({
        overlayOpacity: 0
      })
    } else if (scrollY > maximum) {
      this.setState({
        overlayOpacity: 1
      })
    } else {
      const scrollOffset = scrollY - minimum
      const scrollMaxOffset = maximum - minimum
      const opacity = 1 - Math.max(1 - ((scrollOffset * 100 / scrollMaxOffset) / 100), 0)
      this.setState({
        overlayOpacity: opacity
      })
    }
  }

  handleResize () {
    this.calculateArticleHeightRestriction()
  }

  handleArticleRef (element) {
    this.articleRef = element
  }

  updateArticleHeightRestriction (height) {
    this.setState({
      articleHeightRestriction: height
    })
  }

  getArticleStyles () {
    const {articleHeightRestriction} = this.state
    if (!this.isSubscriptionRequired()) return {}
    return {
      height: `${articleHeightRestriction}px`
    }
  }

  getOverlayStyles () {
    const {overlayOpacity} = this.state
    return {
      opacity: `${overlayOpacity}`
    }
  }

  isOverlayVisible () {
    const {overlayOpacity} = this.state
    return (overlayOpacity > 0)
  }

  isSubscriptionRequired () {
    const {subscriptionRequired} = this.props
    return useGatedContent() && subscriptionRequired
  }

  render () {
    const {article, contentType, relatedArticles} = this.props
    const subscriptionRequired = this.isSubscriptionRequired()
    if (!article) {
      return <ErrorPage errorCode={404} />
    }
    return (
      <div className={classNames([
        'ArticlePage',
        {
          'ArticlePage--subscriptionRequired': subscriptionRequired,
          'ArticlePage--overlayVisible': this.isOverlayVisible()
        }
      ])}>
        <div className='ArticlePage__content'>
          <div className='ArticlePage__article' ref={this.handleArticleRef} style={this.getArticleStyles()}>
            <Article article={article} contentType={contentType} relatedArticles={relatedArticles} />
            {
              subscriptionRequired && (
                <div className='ArticlePage__article__overlay' style={this.getOverlayStyles()} />
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

ArticlePage.defaultProps = {
  contentType: CONTENT_TYPE_ARTICLE
}

export default ArticlePage



// WEBPACK FOOTER //
// ./client/pageComponents/ArticlePage/ArticlePage.js